module.exports = __webpack_public_path__ + "img/color_gold_a-2230-1@2x.76254bb.webp";